import { AgmCoreModule } from "@agm/core";
import { registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import ptBr from "@angular/common/locales/pt";
import { LOCALE_ID, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MDBBootstrapModulesPro } from "ng-uikit-pro-standard";
import { CookieService } from "ngx-cookie-service";

import { AppComponent } from "./app.component";
import { AuthModule } from "./auth/auth.module";
import { LoaderHttpComponent } from "./components/loader-http/loader-http.component";
import { AppRoutingModule } from "./core/app-routing.module";
import { ApiKeysInterceptor } from "./interceptors/api-keys.interceptor";
import { LoaderInterceptor } from "./interceptors/loader-interceptor";
import { LoaderService } from "./services/loader.service";
import { SpgModule } from "./spg/spg.module";
import { ErrorInterceptor } from "./interceptors/error.interceptor";

registerLocaleData(ptBr);

@NgModule({
  declarations: [AppComponent, LoaderHttpComponent],
  imports: [
    AuthModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    SpgModule,
    AppRoutingModule,
    MDBBootstrapModulesPro.forRoot(),
    AgmCoreModule.forRoot({
      // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en#key
      apiKey: "Your_api_key",
    }),
  ],
  providers: [
    CookieService,
    {
      provide: LOCALE_ID,
      useValue: "pt-PT",
    },
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiKeysInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule {}
